import { IUserProfile } from "../user/models"

export default class UserAdminState{
    userList:Array<IUserProfile> =[]
    availableTokenList:number[] = []
}